










































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import SettingsMixin from "@/mixins/http/SettingsMixin";
import { FileUpload } from "@/models";
import DateTime from "@/filters/DateTime";
import GenericCable from "@/cables/GenericCable";
import MediumProgress from "@/models/MediumProgress";
import MediumProgressItem from "./MediumProgressItem.vue";

@Component({ filters: { DateTime }, components: { MediumProgressItem } })
export default class MediumAudienceUploadProgress extends Mixins(
  SettingsMixin
) {
  @Prop({ default: () => null }) readonly fileUpload!: FileUpload | null;
  uploads: FileUpload[] = [];
  mediaProgressList: MediumProgress[] = [];
  cable: GenericCable | null = null;
  genericError = "";

  @Watch("fileUpload")
  fileUploadChanged(value: FileUpload) {
    this.genericError = "";
    this.unsubscribeToChannel();
    this.subscribeToChannel(value);
  }

  async mounted() {
    this.loading = true;
    this.uploads = await this.getFileUploads();
    this.loading = false;
  }

  destroyed() {
    this.unsubscribeToChannel();
  }

  get lastDatabase() {
    if (this.uploads.length > 0) {
      return this.uploads[0];
    } else {
      return null;
    }
  }

  subscribeToChannel(fileUpload: FileUpload) {
    this.cable = new GenericCable("FileUploadsChannel");
    this.cable.onResponse = this.onResponse;
    this.cable.open({ id: fileUpload.id });
  }

  onResponse(data: any) {
    const progress: MediumProgress = this.$parseModel(data);
    if (progress && data.status === 200) {
      let listedProgress =
        this.mediaProgressList.find((p) => p.id === progress.id) || null;
      if (listedProgress === null) {
        listedProgress = progress;
        this.mediaProgressList.push(progress);
      } else {
        if (progress.status !== "failed") {
          listedProgress.progress = progress.progress;
          listedProgress.status = progress.status;
        } else {
          listedProgress.status = "failed";
        }
      }
    } else {
      if (!data.medium) {
        if (data.msg) {
          this.genericError = data.msg;
        }
      } else {
        let listedProgress =
          this.mediaProgressList.find(
            (p) => p.broadcasterName === data.medium
          ) || null;
        if (listedProgress && data.msg) {
          listedProgress.errors = data.msg;
        }
        if (listedProgress && data.errors) {
          listedProgress.errors = data.errors
            .map((error: any) => error.message)
            .join(" ");
        }
      }
    }
  }

  unsubscribeToChannel() {
    if (this.cable) {
      this.cable.close();
      this.cable = null;
    }
  }

  private loading = false;
}
